import { Box, Button } from '@mui/material';
import { getTrans } from 'modules/i18n';
import { useEditModeNavigation } from '../hooks/useEditModeNavigation';

export const EditModeNavigationButtons = () => {
  const { handleUpdate, handleDiscard } = useEditModeNavigation();

  return (
    <Box
      data-testid="edit-mode-buttons"
      sx={{ display: 'flex', gap: 2, mt: 3 }}
    >
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleDiscard}
        fullWidth
      >
        {getTrans('general.discard')}
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={handleUpdate}
        fullWidth
      >
        {getTrans('general.update')}
      </Button>
    </Box>
  );
};
